/**
 * Image with fallback component support
 */
import { useEffect, useState } from 'react';
import './styles.scss';

interface IProps {
    src: string | undefined;
    size: 'xs' | 's' | 'm' | 'l';
    onClick?: any
    props?: any
    className?: string
    fallback: any;
}

const FallbackImage = (props: IProps) => {
  const [fallback, setFallback] = useState(false);
  useEffect(() => {
    setFallback(false);
  }, [props.src]);

  if (!props.src) {
    return <div className={`image image--${props.size}`}></div>;
  }
  if (fallback) {
    return props.fallback;
  }
  return <img
    {...props}
    onClick={props.onClick ? props.onClick : undefined}
    onMouseDown={(e) => e.preventDefault()}
    className={`image image--${props.size} ${props.className ? props.className : ''}`}
    onError={() => setFallback(true)}
    src={props.src}
    alt=""
  />;
};

export default FallbackImage;